import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import TablePagination from "@mui/material/TablePagination";
import {
  Box,
  Container,
  Dialog,
  DialogContent,
  Icon,
  Toolbar,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { red, green } from "@mui/material/colors";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Edit from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";


import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
// import { tableContainerStyle, tableStyle } from "../../../../utils/style";

// import { Tsmsvali } from "../../../Validation";
import HomeIcon from "@mui/icons-material/Home";
import { dateFormat } from "../../../utils/Date";
import ComponentLoader from "../../../ComponentLoader";

// import './App.css'

function ARA7({ head }) {
  const Navigate = useNavigate("");

  const nextButton = () => {
    Navigate("/ArA8")
  };

  const Previousbutton = () => {
    Navigate("/ArA6")
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(red[500]),
    textTransform: "none",
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
  }));

  const theme = useTheme();
  const [dataList, setDatalist] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [ii,setI] =useState(null)  

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);
  const [loader,setLoader] =useState(false)

  const navigate = useNavigate();
  const location = useLocation();
  const [Mname, setName] = useState("");
const [disables, setDisables] = useState(false);
const [role, setRole] = useState("");

  const {
      register,
      handleSubmit,
      formState: { errors, isValid },
      setValue,
      reset,
      watch,
  } = useForm({
      // resolver: yupResolver(Tsmsvali),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);

    if (tok != null && tok != undefined) {
      if (myObject !== null) {
        handleDatalist(tok, myObject.id);
        setI(myObject.id)
      }
    }
    const role = localStorage.getItem("role");
    setRole(role);
    var dis = localStorage.getItem("disable");
    if (dis !== null) {
      setDisables(true);
    } else {
      setDisables(false);
    }
    let isTrue = localStorage.getItem("Mname");
    if (isTrue !== null) {
      setName(isTrue);
    }
    head(" Student Guidance");
  }, []);

  const edit = (item) => {
    navigate("/ArA7Inside", { state: item });
    console.log(item);
    setOpen(true);
    setId(item.id);
  };

  const onclickDelete = async (id) => {
    const result = window.confirm("Are you sure you want to delete?");
    if (result) {
      // Perform the delete operation
      deleteTransaction(id);
      console.log("Deleted successfully");
      // window.location.reload();
    } else {
      // Cancelled delete operation
      console.log("Delete cancelled");
    }
  };

  const deleteTransaction = async (id) => {
    const d = {
      Id: id,
    };
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.post(`${window.BASE}${window.ArA7DELETE}`, d, {
        headers: h,
      });
      handleDatalist(token,ii)  
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDatalist = async (token, id) => {
    console.log(token);setLoader(true)
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const { data } = await axios.get(
        `${window.BASE}${window.ArA7GETALL}${"/" + id}`,
        { headers: h }
      );
      console.log(data);setLoader(false)
      setDatalist(data);
    } catch (error) {
      console.log(error);setLoader(false)
    }
  };

  const handleClickOpen = () => {
   Navigate("/ArA7Inside")
    setOpen(true);
  };

  return (
    <div className="main-container-margin">
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/GeneralAR">
            <HomeIcon style={{ color: "white", marginLeft: 38 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>A7.Details on TSMS non-submission</span>
        </div>
      </div>

      <div className="tables-main">
        <div style={{ marginLeft: 20 }}>
          <button className="tables-btn" onClick={Previousbutton}>
            <div className="sidebar-icon" />
            Previous
          </button>
        </div>
        <div style={{ marginRight: 20 }}>
          <button className="tables-btn" onClick={nextButton}>
            Next
            {/* FD5B14 */}
            <div className="sidebar-icon" />
          </button>
        </div>
      </div>
      <div className="table-container-grid">
        <div className="table-head">
          {/* <div>
                    <button className='top-butto'  onClick={backButton}>

                        <ArrowBackIcon style={{ marginBottom: 3 }} className="sidebar-icon" />
                        Back</button>
                </div> */}
          <div>
            <button className="top-button" onClick={handleClickOpen} disabled={role === "Director" ? true : !disables ? false : true}>
              + Add
            </button>
          </div>
        </div>

        
        {/* ************************* */}

        <TableContainer>
          <Table
            
            aria-labelledby="tableTitle"
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead className="headtable">
              {/* <TableCell >Name</TableCell>
                        <TableCell >Designation</TableCell> */}

              <TableCell >Name</TableCell>
              <TableCell >Designation</TableCell>
              <TableCell >Date of non-submission</TableCell>
              <TableCell >Reason</TableCell>
              <TableCell >Option</TableCell>
            </TableHead>

            <TableBody>
              {dataList?.map((row) => (
                <TableRow key={row.Natureofcoaching}>
                  <TableCell >{row.investigatorName}</TableCell>
                  <TableCell >{row.designation}</TableCell>
                  <TableCell >{dateFormat(row.date)}</TableCell>
                  <TableCell > {row.reason}</TableCell>
                 
                    <TableCell >
                    <div className="edit-delete">
                      <button className="tablebutton" onClick={() => edit(row)} disabled={role === "Director"? true : !disables ? false : true}>
                        {<Edit className="sidebars-icon" />}
                      </button>

                      <button
                        className="deleted"
                        style={{ marginLeft: 3 }}
                        onClick={() => onclickDelete(row.id)}
                        disabled={role === "Director"? true : !disables ? false : true}
                      >
                        {<DeleteIcon className="sidebars-icon" />}
                      </button>
                      </div>
                    </TableCell>
                  
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}
export default ARA7;
